import DashboardTour from './DashboardTour';

export default DashboardTour;
